// PT Scroll stack. The stacking itself is CSS (position: sticky), this only
// scales down the cards that are already covered by a later one.

// How much a card shrinks per card lying on top of it.
const SCALE_STEP = 0.085;
// Share of the viewport a card travels while the cards behind it shrink.
const RAMP = 0.4;

const initScrollStack = (stack) => {
  const items = [...stack.querySelectorAll('.scroll-stack__item')];

  if (items.length < 2) {
    return;
  }

  const cards = items.map((item) => item.querySelector('.scroll-stack__card'));
  let stickyTops = [];
  let ticking = false;

  // All cards are as high as the highest one, so no card peeks out below.
  const measure = () => {
    cards.forEach((card) => {
      card.style.minHeight = '';
    });

    const tallest = Math.max(...cards.map((card) => card.offsetHeight));

    cards.forEach((card) => {
      card.style.minHeight = `${tallest}px`;
    });

    stickyTops = items.map(
      (item) => parseFloat(window.getComputedStyle(item).top) || 0,
    );
  };

  const update = () => {
    ticking = false;

    const ramp = window.innerHeight * RAMP;
    // 0 = card has not reached its resting position yet, 1 = it is stacked.
    const progress = items.map((item, index) => {
      const travelled =
        stickyTops[index] + ramp - item.getBoundingClientRect().top;

      return Math.min(Math.max(travelled / ramp, 0), 1);
    });

    items.forEach((item, index) => {
      const covered = progress
        .slice(index + 1)
        .reduce((sum, value) => sum + value, 0);

      item.style.setProperty(
        '--stack-scale',
        (1 - covered * SCALE_STEP).toFixed(4),
      );
    });
  };

  const request = () => {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(update);
  };

  measure();
  update();

  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', () => {
    measure();
    request();
  });
};

export default initScrollStack;
